/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureRestorePointSpec } from '../models/AzureRestorePointSpec';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';

export class ConvertOtherSnapshotsOnDemandRequest {
  /**
  * The ID of the vault
  */
  'vaultId': string;
  /**
  * The number of days to retain the backup
  */
  'retentionDays': number;
  /**
  * AWS EBS snapshot details - one entry per volume (use for AWS resources)
  */
  'snapshotDetails'?: Array<ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner>;
  /**
  * Azure restore point details - one entry per restore point, containing multiple disks (use for Azure resources)
  */
  'azureRestorePoints'?: Array<AzureRestorePointSpec>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    },
    {
      "name": "snapshotDetails",
      "baseName": "snapshotDetails",
      "type": "Array<ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner>",
      "format": ""
    },
    {
      "name": "azureRestorePoints",
      "baseName": "azureRestorePoints",
      "type": "Array<AzureRestorePointSpec>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConvertOtherSnapshotsOnDemandRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

